import { render, staticRenderFns } from "./file-choser.vue?vue&type=template&id=2fb2fe2a&"
import script from "./file-choser.vue?vue&type=script&lang=js&"
export * from "./file-choser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports